import { render, staticRenderFns } from "./BaseVSelectComplex.vue?vue&type=template&id=2519a8ea"
import script from "./BaseVSelectComplex.vue?vue&type=script&lang=js"
export * from "./BaseVSelectComplex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports